module.exports = __webpack_public_path__ + "static/img/8.d4fbbbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/8.png
// module id = NDtl
// module chunks = 0